import { Adapter as a, getAdapter as t } from "../../../../adapter.js";
import { AdyenPaymentMethodAdapter as d } from "../adyenPaymentMethod/adyenPaymentMethod.adapter.js";
import { AdyenStoredPaymentMethodAdapter as r } from "../adyenStoredPaymentMethod/adyenStoredPaymentMethod.adapter.js";
import { AdyenEngineConfigModel as p } from "./adyenEngineConfig.model.js";
class A extends a {
  adapt(e) {
    const n = t(r), o = t(d);
    return new p({
      clientKey: e.adyen.client_key,
      environment: e.adyen.environment,
      paymentMethods: (e.adyen.payment_methods ?? []).map(o.adapt),
      storedMethods: (e.adyen.stored_payment_methods ?? []).map(n.adapt)
    });
  }
  serialize(e) {
    const n = t(r), o = t(d);
    return {
      client_key: e.clientKey,
      environment: e.environment,
      payment_methods: e.paymentMethods.map(o.serialize),
      stored_methods: e.storedMethods.map(n.serialize)
    };
  }
}
export {
  A as AdyenEngineConfigAdapter
};
//# sourceMappingURL=adyenEngineConfig.adapter.js.map
